import * as Sentry from '@sentry/react'

export function captureForcedLogout(area, extra = {}) {
  if (typeof Sentry.captureException !== 'function') return
  Sentry.captureException(new Error('forced-logout'), {
    level: 'error',
    tags: { area: `forced-logout.${area}` },
    extra,
  })
}

// 사용자에게는 조용히 처리되지만(예: 폴백 redirect) 원인을 남겨야 하는 에러용.
// 강제 로그아웃이 아닌 일반 handled error 를 area 태그와 함께 기록한다.
export function captureHandledError(area, error, extra = {}) {
  if (typeof Sentry.captureException !== 'function') return
  Sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
    level: 'error',
    tags: { area },
    extra,
  })
}
